var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNgfNorwegianTotalSounding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,2c3.692,0,6.915,2.016,8.647,5H3.353c1.732-2.984,4.955-5,8.647-5ZM2,12c0-1.045.163-2.052.461-3h8.539v12.949c-5.046-.504-9-4.773-9-9.949Zm11,9.949v-12.949h8.539c.299.948.461,1.955.461,3,0,5.176-3.954,9.446-9,9.949Z",
    fill: "#1c1c1b",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNgfNorwegianTotalSounding);
export default __webpack_public_path__ + "static/media/icon-ngf-norwegian-total-sounding.4b7428ea97f25444f65d347397b1e39d.svg";
export { ForwardRef as ReactComponent };